import React, { FC } from "react";
import { GroupRuleSearchPattern, GroupRuleSearchPatternType } from "../../../../../models/groupRule";
import SelectInput from "../../shared/fields/selectInput";
import TextInput from "../../shared/fields/textInput";
import ToggleInput from "../../shared/fields/toggleInput";

type Props = {
  addPattern: () => void;
  removePattern: (index: number) => void;
  searchPatterns: GroupRuleSearchPattern[];
  updatePattern: (index: number, property: keyof GroupRuleSearchPattern, value: string | boolean | number) => void;
};

const GroupRuleSearchPatterns: FC<Props> = ({ addPattern, removePattern, searchPatterns, updatePattern }) => {
  return (
    <div className="form-group">
      <label>Search Patterns</label>
      <table className="table border" style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>
              <label>Pattern</label>
            </th>
            <th>
              <label>Type</label>
            </th>
            <th>
              <label>Case Sensitive</label>
            </th>
            <th>
              <label>Regex</label>
            </th>
            <th>
              <label>Action</label>
            </th>
          </tr>
        </thead>
        <tbody>
        {searchPatterns.map((pattern, index) => (
          <tr key={index}>
            <td>
              <TextInput
                name={`pattern-${index}`}
                onChange={(value): void => updatePattern(index, "pattern", value)}
                value={pattern.pattern}
              />
            </td>
            <td>
              <SelectInput
                name={`type-${index}`}
                onChange={(id): void => {
                  if (id !== null) {
                    updatePattern(index, "searchPatternType", id);
                  }
                }}
                id={pattern.searchPatternType}
                options={[
                  { id: GroupRuleSearchPatternType.AttachmentName, label: "Attachment Name" },
                  { id: GroupRuleSearchPatternType.EmailOrAttachmentContent, label: "Email or Attachment Content" },
                  { id: GroupRuleSearchPatternType.Subject, label: "Subject" },
                ]}
                notNull
              />
            </td>
            <td>
              <ToggleInput
                name={`pattern-case-${index}`}
                onChange={(value): void => updatePattern(index, "isCaseSensitive", value)}
                value={pattern.isCaseSensitive}
              />
            </td>
            <td>
              <ToggleInput
                label=""
                name={`pattern-regex-${index}`}
                onChange={(value): void => updatePattern(index, "isRegex", value)}
                value={pattern.isRegex}
              />
            </td>
            <td>
              <button
                id={`delete-pattern-${index}`}
                className="btn btn-primary btn-sm mb-4"
                style={{ width: "50%" }}
                onClick={(): void => removePattern(index)}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
        <tr>
          <td colSpan={5} className="text-right">
            <button type="button" className="btn btn-primary btn-sm" onClick={addPattern}>
              Add Pattern
            </button>
          </td>
        </tr>
        </tbody>
    </table>
</div>
  );
};

export default GroupRuleSearchPatterns;